import { db } from "../firebase";

// Chequea si currentUid puede iniciar una conversación con targetUid, según
// la preferencia "mensajesDe" de targetUid (ajustes.js -> Preferencias de
// privacidad -> "Quién puede enviarte mensajes"): 'todos' (default) |
// 'seguidos' (solo gente a la que targetUid sigue) | 'nadie'. Mismos nombres
// de campo/valores que ya usaba user.js (/user/:userId, no enlazado desde
// ningún lado pero con esta lógica ya escrita) — se reutiliza acá para que
// el ajuste sirva para algo real desde los puntos de entrada que sí están
// enlazados (members.js, UserMap.js).
export const canMessageUser = async (targetUid, currentUid) => {
  if (!targetUid || !currentUid || targetUid === currentUid) return true;
  try {
    const targetSnap = await db.doc(`users/${targetUid}`).get();
    const mensajesDe = targetSnap.exists ? targetSnap.data().mensajesDe || "todos" : "todos";
    if (mensajesDe === "nadie") return false;
    if (mensajesDe === "seguidos") {
      const followingSnap = await db.doc(`userFollowing/${targetUid}`).get();
      return !!(followingSnap.exists && followingSnap.data()[currentUid]);
    }
    return true;
  } catch (error) {
    console.error("Error al verificar si se puede enviar mensaje:", error);
    return true; // fail-open: un error de red no debería bloquear el chat
  }
};
